import React from 'react';

const Footer = () => {
    const footerStyle = {
        borderTop: '1px solid #e2e8f0',
        fontSize: '0.75rem',
        color: '#5a6e7c',
        textAlign: 'center',
        padding: '20px 0',
        marginTop: '25px',
        backgroundColor: 'white',
        width: '100%',
    };

    return (
        <div style={footerStyle}>
            <span>© 2026 Venkatadri Seva Trust</span>
        </div>
    );
};

export default Footer;